var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 6.16671H13.1668V8.50004H10.8335V6.16671ZM10.8335 10.8334H13.1668V17.8334H10.8335V10.8334ZM12.0002 0.333374C5.56016 0.333374 0.333496 5.56004 0.333496 12C0.333496 18.44 5.56016 23.6667 12.0002 23.6667C18.4402 23.6667 23.6668 18.44 23.6668 12C23.6668 5.56004 18.4402 0.333374 12.0002 0.333374ZM12.0002 21.3334C6.85516 21.3334 2.66683 17.145 2.66683 12C2.66683 6.85504 6.85516 2.66671 12.0002 2.66671C17.1452 2.66671 21.3335 6.85504 21.3335 12C21.3335 17.145 17.1452 21.3334 12.0002 21.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon_exclamation.6b9bbeb97ab0967131904f7533678fb4.svg";
export { ForwardRef as ReactComponent };